/* Florema · Popup de bienvenida (D6 v3). Markup: snippets/florema-popup-bienvenida.liquid · Estilos: florema-popup.css
   - Aparece a los 8 s o al intentar salir (escritorio), una vez por visitante. Guarda en localStorage "flpop_v1".
   - Tras cerrar: no se abre solo por 7 días y queda la pestaña "10% en tu primera compra" (abre de nuevo).
   - Tras suscribirse: nunca más. Prueba: ?flpop=1 lo fuerza (ignora lo guardado y no escribe nada).
   - Envío por fetch al formulario nativo de clientes de Shopify; si Shopify pide verificación (/challenge) cae a envío normal. */
(function () {
  'use strict';
  var root = document.getElementById('flpop');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var KEY = 'flpop_v1', PENDING = 'flpop_pending', DIAS7 = 7 * 24 * 60 * 60 * 1000, ESPERA = 8000, SALIDA_MIN = 3000;
  var CODE = root.getAttribute('data-code') || 'BIENVENIDO-10';
  var qs = location.search, force = /[?&]flpop=1(&|$)/.test(qs);
  var path = (location.pathname.replace(/\/+$/, '') || '/').toLowerCase();
  var excluida = /^\/(cart|checkouts?|account|challenge)(\/|$)/.test(path) || /^\/pages\/(mayoristas|descubre-tu-aroma)(\/|$)/.test(path);

  /* ---------- almacenamiento (siempre en try/catch) ---------- */
  function leer() { try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && typeof v === 'object' ? v : null; } catch (e) { return null; } }
  function guardar(s) { if (force) return; try { localStorage.setItem(KEY, JSON.stringify({ s: s, t: Date.now() })); } catch (e) {} }
  function pend(v) { try { if (v === undefined) return sessionStorage.getItem(PENDING); if (v) sessionStorage.setItem(PENDING, '1'); else sessionStorage.removeItem(PENDING); } catch (e) {} return null; }

  /* ---------- elementos ---------- */
  var $ = function (id) { return document.getElementById(id); };
  var ov = $('flpop-ov'), dlg = $('flpop-dlg'), tab = $('flpop-tab'), tabBtn = $('flpop-tabbtn'), tabX = $('flpop-tabx'), form = $('flpop-form'), ok = $('flpop-ok'), live = $('flpop-live');
  var nm = $('flpop-nm'), em = $('flpop-em'), nmErr = $('flpop-nmErr'), emErr = $('flpop-emErr'), formErr = $('flpop-formErr'), btn = $('flpop-submit');
  var video = $('flpop-vid');
  if (!ov || !dlg || !tab || !tabBtn || !tabX || !form || !ok || !nm || !em) return;

  var reduce = false, ahorro = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  try { ahorro = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
  var mqCel = matchMedia('(max-width:700px)');
  var FOC = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var abierto = false, enviando = false, suscrito = false, cierre = null, autoHecho = false, t0 = Date.now(), ultimoFoco = null;

  /* ---------- video: ancho (escritorio) o alto (celular); se descarga recién al abrir ---------- */
  function tipo() { return mqCel.matches ? 'alto' : 'ancho'; }
  function videoPlay() {
    if (!video) return;
    var k = tipo();
    video.setAttribute('poster', root.getAttribute('data-poster-' + k) || '');
    if (reduce || ahorro) return;                         // solo la foto
    if (video.getAttribute('data-kind') !== k) {
      video.setAttribute('data-kind', k);
      video.setAttribute('src', root.getAttribute('data-src-' + k) || '');
      try { video.load(); } catch (e) {}
    }
    var p = video.play(); if (p && p.catch) p.catch(function () {});
  }
  function videoPause() { try { video && video.pause(); } catch (e) {} }
  var onMq = function () { if (abierto) videoPlay(); };
  if (mqCel.addEventListener) mqCel.addEventListener('change', onMq); else if (mqCel.addListener) mqCel.addListener(onMq);

  /* ---------- validación ---------- */
  var validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()); };
  var validName = function (v) { return String(v).trim().length >= 2; };
  function limpia(inp, err) { err.textContent = ''; inp.removeAttribute('aria-invalid'); }
  function falla(inp, err, msg) { err.textContent = msg; inp.setAttribute('aria-invalid', 'true'); }
  nm.addEventListener('input', function () { if (nmErr.textContent && validName(nm.value)) limpia(nm, nmErr); });
  em.addEventListener('input', function () { if (emErr.textContent && validEmail(em.value)) limpia(em, emErr); });

  /* ---------- abrir / cerrar ---------- */
  var peekHecho = false, peekT = null, tabOculta = false;
  try { tabOculta = sessionStorage.getItem('flpop_tabx') === '1'; } catch (e) {}
  function mostrarPestana(si) {
    if (si && tabOculta) return;                                           // la cerró con la × en esta sesión
    if (!si) { tab.classList.remove('is-show', 'is-peek'); setTimeout(function () { if (!tab.classList.contains('is-show')) tab.hidden = true; }, 650); return; }
    tab.hidden = false; reubicar(); void tab.offsetWidth; tab.classList.add('is-show');
    // escritorio: la etiqueta "Tu 10% te espera" se desliza una vez a los 2 s y se recoge
    if (!peekHecho && !reduce && matchMedia('(min-width:701px) and (hover:hover)').matches) {
      peekHecho = true;
      peekT = setTimeout(function () { tab.classList.add('is-peek'); peekT = setTimeout(function () { tab.classList.remove('is-peek'); }, 2800); }, 2000);
    }
  }
  tabX.addEventListener('click', function (e) {
    e.stopPropagation(); tabOculta = true; try { sessionStorage.setItem('flpop_tabx', '1'); } catch (er) {}
    clearTimeout(peekT); mostrarPestana(false);
  });

  /* ---------- la insignia nunca tapa nada: se sube sobre las barras fijas de abajo (barra de compra de la ficha, avisos, cookies...) ---------- */
  var cand = [], candT = null, recT = null, ro = null, mo = null;
  function esMio(el) { return root.contains(el); }
  function escanear() {
    var nuevos = [], todos = document.body.querySelectorAll('*'), vh = innerHeight;
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i]; if (esMio(el)) continue;
      var tag = el.tagName; if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'SVG' || tag === 'PATH' || tag === 'IMG' || tag === 'SPAN' || tag === 'LI' || tag === 'P') continue;
      var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      nuevos.push(el);
    }
    cand = nuevos;
    if (ro) { ro.disconnect(); mo && mo.disconnect(); cand.forEach(function (el) { ro.observe(el); mo && mo.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] }); }); }
    reubicar();
  }
  function altoBarras() {
    var vw = innerWidth, vh = innerHeight, max = 0;
    for (var i = 0; i < cand.length; i++) {
      var el = cand[i]; if (!el.isConnected) continue;
      var r = el.getBoundingClientRect();
      if (r.width < vw * 0.4 || r.height <= 0 || r.height > vh * 0.35) continue;          // solo barras anchas y bajas (no cajones ni pantallas completas)
      if (vh - r.bottom > 4 || r.top >= vh - 1 || r.bottom <= 0) continue;                // ancladas abajo y a la vista (fuera de pantalla = no cuenta)
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) continue;
      var h = vh - Math.max(r.top, 0); if (h > max) max = h;
    }
    return max;
  }
  function reubicar() {
    recT = null;
    var b = Math.round(altoBarras());
    root.style.setProperty('--flpop-b', (b > 0 ? b + 12 : (mqCel.matches ? 10 : 24)) + 'px');
  }
  function pedirReubicar() { if (recT) return; recT = setTimeout(reubicar, 120); }
  function iniciarOffset() {
    escanear();
    window.addEventListener('scroll', pedirReubicar, { passive: true });
    window.addEventListener('resize', function () { pedirReubicar(); clearTimeout(candT); candT = setTimeout(escanear, 600); });
    document.addEventListener('transitionend', pedirReubicar, true);
    if (window.ResizeObserver) ro = new ResizeObserver(pedirReubicar);
    if (window.MutationObserver) {
      mo = new MutationObserver(pedirReubicar);
      new MutationObserver(function () { clearTimeout(candT); candT = setTimeout(escanear, 700); }).observe(document.body, { childList: true });   // banners que aparecen después
    }
    escanear();
    setTimeout(escanear, 1500); setTimeout(escanear, 4500); window.addEventListener('load', function () { setTimeout(escanear, 400); });
  }

  function abrir(origen) {
    if (abierto) return;
    abierto = true; autoHecho = true; clearTimeout(cierre);
    ultimoFoco = document.activeElement;
    ov.hidden = false; document.documentElement.classList.add('flpop-lock'); document.body.classList.add('flpop-open');
    mostrarPestana(false);
    void ov.offsetWidth; ov.classList.add('is-open');
    if (!suscrito) guardar('shown');
    videoPlay();
    setTimeout(function () { (suscrito ? $('flpop-okT') : nm).focus({ preventScroll: true }); }, reduce ? 0 : 400);
    document.addEventListener('keydown', teclas, true);
  }
  function cerrar() {
    if (!abierto) return;
    abierto = false;
    ov.classList.remove('is-open'); document.documentElement.classList.remove('flpop-lock'); document.body.classList.remove('flpop-open');
    cierre = setTimeout(function () { ov.hidden = true; }, reduce ? 0 : 520);
    videoPause();
    document.removeEventListener('keydown', teclas, true);
    if (!suscrito) { guardar('closed'); mostrarPestana(true); try { if (!tabOculta) tabBtn.focus({ preventScroll: true }); } catch (e) {} }
    else if (ultimoFoco && ultimoFoco.focus) { try { ultimoFoco.focus({ preventScroll: true }); } catch (e) {} }
  }
  function teclas(e) {
    if (!abierto) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); cerrar(); return; }
    if (e.key !== 'Tab') return;
    var els = [].slice.call(dlg.querySelectorAll(FOC)).filter(function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
    if (!els.length) { e.preventDefault(); dlg.focus(); return; }
    var f = els[0], l = els[els.length - 1], a = document.activeElement;
    if (!dlg.contains(a)) { e.preventDefault(); f.focus(); }
    else if (e.shiftKey && (a === f || a === dlg)) { e.preventDefault(); l.focus(); }
    else if (!e.shiftKey && a === l) { e.preventDefault(); f.focus(); }
  }
  ov.addEventListener('mousedown', function (e) { if (e.target === ov) cerrar(); });
  [].forEach.call(root.querySelectorAll('[data-flpop-close]'), function (b) { b.addEventListener('click', cerrar); });
  tabBtn.addEventListener('click', function () { abrir('pestana'); });

  /* ---------- estado de éxito ---------- */
  function exito(nombre) {
    suscrito = true; guardar('subscribed'); pend(false);
    var n = String(nombre || nm.value || '').trim().split(/\s+/)[0];
    $('flpop-okT').textContent = n ? 'Listo, ' + n + '. Tu código es este.' : 'Listo. Tu código es este.';
    form.hidden = true; ok.hidden = false; mostrarPestana(false);
    dlg.setAttribute('aria-labelledby', 'flpop-okT');
    live.textContent = 'Listo. Tu código es ' + CODE;
    var t = $('flpop-okT'); if (abierto) t.focus({ preventScroll: true });
  }

  /* ---------- envío por fetch ---------- */
  function setEnviando(si) { enviando = si; btn.disabled = si; btn.textContent = si ? 'Enviando…' : 'Quiero mi 10%'; }
  function errorForm(msg) { formErr.textContent = msg || ''; }
  /* Envío normal del formulario nativo de Shopify, con su protección antispam (hCaptcha) intacta:
     validamos primero (fase de captura en window, antes que el script antispam); si está bien, dejamos que
     Shopify envíe y recargue con ?customer_posted=true, y al volver mostramos el código. */
  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    errorForm('');
    var bad = null;
    if (!validName(nm.value)) { falla(nm, nmErr, nm.value.trim() ? 'Escribe tu nombre completo (2 letras o más).' : 'Cuéntanos tu nombre para saludarte.'); bad = bad || nm; } else limpia(nm, nmErr);
    if (!validEmail(em.value)) { falla(em, emErr, em.value.trim() ? 'Revisa tu correo: parece que falta algo.' : 'Escribe tu correo para enviarte el código.'); bad = bad || em; } else limpia(em, emErr);
    if (bad || enviando) { e.preventDefault(); e.stopImmediatePropagation(); if (bad) bad.focus(); return; }
    setEnviando(true);
    pend(true);
    try { sessionStorage.setItem('flpop_nombre', nm.value.trim()); } catch (er) {}
  }, true);

  /* ---------- copiar ---------- */
  $('flpop-copy').addEventListener('click', function () {
    var b = this, label = b.getAttribute('data-l') || b.textContent; b.setAttribute('data-l', label);
    function listo() { b.textContent = 'Copiado'; b.classList.add('is-ok'); live.textContent = 'Código copiado'; setTimeout(function () { b.textContent = label; b.classList.remove('is-ok'); live.textContent = ''; }, 2200); }
    function alt() { var t = document.createElement('textarea'); t.value = CODE; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); listo(); }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(CODE).then(listo, alt); else alt();
  });

  /* ---------- cuándo mostrarlo ---------- */
  function bloqueado() {
    var cart = document.querySelector('.florema-cart-drawer[aria-hidden="false"], cart-drawer.active, details[open].menu-drawer__submenu');
    var a = document.activeElement, escribiendo = a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a);
    return !!(cart || escribiendo || document.hidden);
  }
  function intentar(n) {
    if (abierto || autoHecho) return;
    if (bloqueado() && n < 6) { setTimeout(function () { intentar(n + 1); }, 4000); return; }   // no interrumpir carrito ni escritura
    abrir('auto');
  }
  function ok_para_auto() {
    if (force) return true;
    var s = leer();
    if (!s) return true;
    if (s.s === 'subscribed') return false;
    return (Date.now() - (s.t || 0)) > DIAS7;
  }
  function iniciar() {
    var s = leer();
    // Volvió del envío normal (verificación de Shopify): la URL trae customer_posted=true y es nuestro formulario
    if (/[?&]customer_posted=true/.test(qs) && (pend() || /contact(%5B|\[)tags(%5D|\])=popup-bienvenida/i.test(qs))) {
      var m = /contact(?:%5B|\[)first_name(?:%5D|\])=([^&#]*)/i.exec(qs), n = ''; try { n = sessionStorage.getItem('flpop_nombre') || ''; } catch (er) {}
      try { if (m) n = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) {}
      pend(false); guardar('subscribed');
      suscrito = true; exito(n);
      setTimeout(function () { abrir('retorno'); }, 400);
      return;
    }
    if (s && s.s === 'subscribed' && !force) return;                    // nunca más después de suscribirse
    if (s && !force) mostrarPestana(true);                              // ya lo vio: queda la pestaña
    if (!ok_para_auto()) return;
    if (force) { setTimeout(function () { abrir('forzado'); }, 600); return; }
    setTimeout(function () { intentar(0); }, ESPERA);
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {        // intención de salida (solo escritorio)
      document.addEventListener('mouseout', function (e) {
        if (!autoHecho && !e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > SALIDA_MIN) intentar(0);
      });
    }
  }

  if (excluida) { root.parentNode && root.parentNode.removeChild(root); return; }   // /cart, /checkout, /account, /challenge, /pages/mayoristas, /pages/descubre-tu-aroma (test de aroma)
  iniciarOffset();
  iniciar();

  /* ayuda para pruebas desde la consola: FlPopup.abrir() / .cerrar() / .reiniciar() */
  window.FlPopup = {
    abrir: function () { abrir('manual'); },
    cerrar: cerrar,
    reiniciar: function () { try { localStorage.removeItem(KEY); sessionStorage.removeItem(PENDING); } catch (e) {} location.reload(); }
  };
})();
